import React, { useState, useEffect, useRef } from 'react'
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import CountUp from 'react-countup'
import { StaticImage } from 'gatsby-plugin-image'
import { graphql, Link } from 'gatsby'
import Fade from 'react-reveal/Fade'
import { useScrollYPosition } from 'react-use-scroll-position'
import { StickyContainer, Sticky } from 'react-sticky';

import ResponsiveContainer from 'components/utils/ResponsiveContainer'
import Layout from 'components/Layout'
import TwoColumns from 'components/utils/TwoColumns'
import VisibilitySensorOnce from 'components/utils/VisibilitySensorOnce'
import PageHero from 'components/UI/PageHero'
import LogoKemkominfo from 'images/logo-kominfo.inline.svg'
import { Header3, Header4, HeaderUnderline } from 'components/UI/Header'
import CategoryButton from 'components/UI/CategoryButton'

import ListItem from 'components/Pages/Agenda/ListItem'


const Update = ({ data }) => {

    const scheduleList = data.allStrapiSchedule.edges.map(item => { return {...item.node} })
    scheduleList.sort(function(a,b){
      return new Date(a.schedule) - new Date(b.schedule);
    });
    return (
      <>
        <Layout pageTitle="Agenda" pageGroup="agenda" floatingHeader>
            <PageHero title="Agenda" bgStyle="dashed" />
            <section className="bg-primary-lighter">
                <ResponsiveContainer className="py-20 lg:py-32 relative">
                    <div className="grid gap-12 grid-cols-1 sm:grid-cols-2">
                        { scheduleList.map( (item, index) => <ListItem data={item} key={ index } /> ) }
                    </div>
                </ResponsiveContainer>
            </section>
            <section>
                <ResponsiveContainer className="py-20">
                      <div className="grid gap-8 grid-cols-1 md:grid-cols-2">
                          <div>
                              <h2 className="text-3xl text-primary font-bold lg:text-4xl ">Integrated platform-based event which provides open access to Indonesia’s tech startup ecosystem.</h2>
                          </div>
                          <div>
                            <p>JEJALA Indonesia is a Venture Capital matchmaking event crafted by the Indonesian Ministry of Communications and Informatics, catering Indonesian early-stage tech startups.</p>
                            <p>We invite global Venture Capitalists to acknowledge and build networks with Indonesian early-stage tech startups, in hopes of sparking investment opportunities in the future.</p>
                            <div className="mt-12">
                                <Link to="/contact" className="py-2 px-4 bg-black text-white font-bold rounded-xl">Register</Link>
                            </div>
                          </div>
                      </div>
                </ResponsiveContainer>
            </section>
        </Layout>
      </>
    )
}

export const pageQuery = graphql`
  query AgendaPageQuery {
    allStrapiSchedule {
      edges {
        node {
          description
          schedule
          title
          strapiId
        }
      }
    }
  }
`


export default Update
